import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { SnackbarLabel } from "../features/common/SnackbarLabel";
import { successSnackbarOptions } from "meta/utils/snackbars";
import { useChartTabsWebEvents } from "./useChartTabsWebEvents";
import { useContentTabWebEvents } from "./useContentTabWebEvents";
import { useEventsWebEvents } from "./useEventsWebEvents";
import { logout } from "../actions/appActions";
import { reloadTopMenu, userLogin, patientSelected as patientSelectedRootReducer } from "../features/slices/rootSlice";
import { user_login as userLogin_public } from "../features/slices/rootPublicSlice";
import { action } from "meta/utils/baseActions";
import { ActionTypes } from "../features/enums";
export const useWebEvents = () => {
    const { enqueueSnackbar } = useSnackbar();
    const toastMessage = (message) => {
        enqueueSnackbar(<SnackbarLabel>{message}</SnackbarLabel>, successSnackbarOptions);
    };
    const { closeCurrentTab, handleEventReload } = useEventsWebEvents(toastMessage);
    const { patientSelected, reload } = useContentTabWebEvents();
    const { refreshVerticalTab } = useChartTabsWebEvents();
    const dispatch = useDispatch();
    const handleWebEvent = async (event) => {
        switch (typeof event === "string" ? event : event.type) {
            case ActionTypes[ActionTypes.RELOAD_CONTENT_TAB]:
                reload(event.data?.DisableCache);
                break;
            case ActionTypes[ActionTypes.REFRESH_VERTICAL_TAB]:
                refreshVerticalTab(event.data?.IgnoreModifyCheck);
                break;
            case ActionTypes[ActionTypes.TOAST_MESSAGE]:
                toastMessage(event.data?.Message);
                break;
            case ActionTypes[ActionTypes.EVENT_SAVED]:
                closeCurrentTab();
                await handleEventReload();
                break;
            case ActionTypes[ActionTypes.USER_LOGOUT]:
                dispatch(logout());
                break;
            case ActionTypes[ActionTypes.USER_LOGIN]:
                dispatch(userLogin(event.data));
                dispatch(userLogin_public(event.data));
                break;
            case ActionTypes[ActionTypes.PATIENT_SELECTED]:
                dispatch(patientSelectedRootReducer(event.data));
                break;
            case ActionTypes[ActionTypes.RELOAD_TOP_MENU]:
                dispatch(reloadTopMenu(event.data?.TopMenus));
                break;
            default:
                dispatch(action(event.type, event.data));
                break;
        }
    };
    const handleModalWebEvent = (event) => {
        switch (event.type) {
            case ActionTypes[ActionTypes.PATIENT_SELECTED]:
                patientSelected(event.data);
                break;
        }
    };
    return { onWebEvent: handleWebEvent, onModalWebEvent: handleModalWebEvent };
};
